export default __webpack_public_path__ + "static/media/556.f444632b.gif";